<template>
<div class="basicStyle">
  <div class="mainBox">
     <div class="home"> 
      <div class="contLeft">
        <div class="leftItem leftItemAct" v-show="item.is_select" v-for="(item, index)  in manual_cate_list" :key="index" >
          {{ item.name }}
        </div>  
        <div class="tableListItem" :class="itemB.id == actId ? 'tableListItemAct' : ''" v-for="(itemB, indexB) in tableList" :key="indexB" @click="cateClick(itemB)">
          <i class="normal"></i>
          {{ itemB.title }}
        </div>

        <div v-if="queryInfo.total > queryInfo.limit" class="paginationBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.page"
            :page-sizes="[25, 50, 75, 100]"
            :page-size="queryInfo.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="queryInfo.total"
            prev-text="上一页"
            next-text="下一页"
          >
          </el-pagination>
        </div>
      </div>
      <div class="contRight">  
       <div class="dirctory">
         <span class="title" @click="manualCateClick()">{{ helpManualInfo.manual_cate_name }}</span> > 详情
       </div>
       <div class="title">
        {{ helpManualInfo.title }}
       </div>
       <div class="time">
        {{ helpManualInfo.created_at }} 
       </div>
       <div v-if="helpManualInfo.content" class="infoCont">
        <div v-html="helpManualInfo.content"></div> 
       </div>  
       <div v-else style="padding: 200px 0" class="cont">
         <el-empty :image-size="100" description="暂无数据"></el-empty>
       </div>
      </div> 

    </div> 
  </div> 
</div>  
</template> 
<script> 
import commonApi from "@/api/common";  
export default {
  name: "helpManualInfo", //帮助手册  
  data() {
    return {
      queryInfo: {
        manual_cate_id: "0",
        title: "",
        limit: 25,
        page: 1,
        total: 0,
      }, 
      manual_cate_list: [],
      tableList: [],
      helpManualInfo: {},
      id:"",
      manual_cate_id: "",
      actId: ''
    };
  },
  computed: { 

  },
  watch: {
      
  },
  created() { 
    if (this.$route.query.id && this.$route.query.manual_cate_id) { 
      this.id = this.$route.query.id 
      this.actId = this.$route.query.id 
      this.queryInfo.manual_cate_id = this.$route.query.manual_cate_id 
      this.getTobHelpManualList(0)
    } 
  },
  methods: {  
    cateClick(e){
      console.log("cateClick", e) 
      this.actId = e.id
      this.getTobHelpManualInfo(e.id) 
    },    
    manualCateClick(){
      this.$router.push({
        path: "/helpManualList",
        query: {
          manual_cate_id: this.helpManualInfo.manual_cate_id, 
        },
      }); 
    },
    getTobHelpManualList(e){ 
      this.queryInfo.is_search = e 
      commonApi.getTobHelpManualList(this.queryInfo).then((res) => {
        if (res.code == 200) { 
          this.tableList = res.data.list 
          this.queryInfo.total = res.data.total 
          this.manual_cate_list = res.data.manual_cate_list 

          if(this.queryInfo.page > 1){
            this.actId = res.data.list[0].id
          }else{
            this.actId = this.id
          }

          
          this.getTobHelpManualInfo(this.actId)
        }
      })
    },
     // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.getTobHelpManualList(0);
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.getTobHelpManualList(0);
    },
    getTobHelpManualInfo(e){
      commonApi.getTobHelpManualInfo({id: e}).then((res) => {
        if (res.code == 200) {
          console.log("getTobHelpManualInfo", res.data); 
          this.helpManualInfo = res.data.info 
        }
      });
    } 
  },
};
</script> 
<style lang="less" scoped> 
  .mainBox{
    padding: 20px; 
    border-radius: 10px;  
    // background-color: #fff; 

    .dirctory{  
      text-align: left;
      font-size: 16px;
      color: #171717;
      margin-bottom: 10px;
      .title{ 
        color: #7861ff; 
        font-size: 16px!important; 
        cursor: pointer;
      }  
    }


    .home {
      width: 100%; 
      box-sizing: border-box; 
      overflow-x: initial;
      display: flex;
      justify-content: space-between; 
      // background: #f7f8fb;
      .contLeft {
        width: 15%;  
        padding: 20px; 
        background-color: #fff;
        margin-right: 40px;
        min-width: 250px;
        
        .leftItem{
          display: none;
          position: relative;
          color: #676767;
          padding-left: 55px;
          box-sizing: border-box;
          height: 36px; 
          line-height: 36px;
          cursor: pointer; 
          
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        } 
        .leftItem::before{
          display: block;
          position: absolute;
          content: "";
          width: 5px;
          height: 5px;
          background: #273758;
          left: 40px;
          top: 0;
          bottom: 0;
          margin: auto;
        }

        .leftItem:hover {
          color: #fff;
          background: #9583ff; 
        }
        .leftItemAct{
          display: block;
          color: #fff;
          background: #9583ff; 
        }

        .tableListItem{
          position: relative;
          color: #676767;
          padding-left: 35px;
          box-sizing: border-box;
          height: 40px; 
          line-height: 40px;
          cursor: pointer;

          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          
          .normal{
            display: inline-block;
            width: 20px;
            height: 20px;
            margin-right: 0px;
            vertical-align: middle; 
            background: url(../../assets/img/iconPrit.png) -118px -6px no-repeat; 
          }
        } 
        .tableListItem:hover {
          color: #9583ff; 
          .normal{ 
            background: url(../../assets/img/iconPrit.png) -90px -6px no-repeat; 
          }
        }
        .tableListItemAct{
          color: #9583ff; 
          .normal{ 
            background: url(../../assets/img/iconPrit.png) -90px -6px no-repeat; 
          } 
        }
      }
      .contRight {
        width: 80%; 
        display: block;
        padding:30px 60px; 
        background-color: #fff; 

        .manual_cate_name{
          font-weight: bold;
          font-size: 16px; 
        }
        
        .rightItem{
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
          white-space: nowrap;
          padding: 24px 0 24px 0;
          box-sizing: border-box;
          border-bottom: 1px dashed #ccc;
          font-size: 16px;
          cursor: pointer;

          .normal{
            display: inline-block;
            width: 20px;
            height: 20px;
            margin-right: 0px;
            vertical-align: middle; 
            background: url(../../assets/img/iconPrit.png) -118px -6px no-repeat; 
          }
        } 
        .rightItem:hover {
          color: #9583ff;

          .normal{ 
            background: url(../../assets/img/iconPrit.png) -90px -6px no-repeat; 
          }
        }
      }
 
      .title{
        text-align: center;
        font-size: 24px;
        font-weight: 800;
      }  
      .time{
        text-align: center;
        font-size: 14px;
        color: #909399; 
        margin-top: 5px;
        margin-bottom: 25px;
      }
      .infoCont{ 
        font-size: 14px;
        color: #000000;
        margin: 0 auto;
        line-height: 140%; 
        max-width: 100%;

        img{
          max-width: 100%;
        }
      } 
      .infoCont::v-deep p img{
          max-width: 100%;
      } 
    }

 
  }

  .dfc{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .paginationBox{
    /deep/.pagination{
      padding: 20px 0;
      text-align: center;
    }
    /deep/ .el-pagination__sizes{
      display: none;
    }
    /deep/ .el-pager{
      display: none;
    }
    /deep/ .el-pagination__jump{
      display: none; 
    } 
    /deep/ .el-pagination .btn-next{
      color: #846ffd;
    } 
    /deep/ .el-pagination .btn-prev{
      color: #846ffd;
    }
    /deep/ .el-pagination button:disabled{
      color: #C0C4CC;
      display: none;
    }
  }
</style>
    